import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditableRow from './EditableRow';
import { formatRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import RepresentanteEditModal from './RepresentantesEditModal';
import DeleteConfirmationModal from 'routes/Pages/FichasTecnicas/Components/DeleteConfirmationModal';
import { TEXT_COLOR_FT } from 'config/config';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
//    border: 'solid 1px',
    borderColor: '#e0e0e0'
  },
});

const RepresentantesCustomTable = ({ headCells, rows, handleSave, handleDelete, profesiones, title, cargo, fields, isPersonal,
  setSelectedRow, openView
}) => {
  const classes = useStyles();
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editedRowData, setEditedRowData] = useState({});

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');

  const [showModalEdit, setShowModalEdit] = useState(false)
  const [showModalDelete, setShowModalDelete] = useState(false)
  const [dataToDelete, setDataToDelete] = useState('')


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredRows = rows.filter((row) => {
    return Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredRows, sortConfig]);

  const openModalDelete = (rowIndex) => {
    setShowModalDelete(true)
    let aux = {
      header: title,
      nombre: rows[rowIndex]['nombre'] + ' ' + rows[rowIndex]['apellido_paterno'] + ' ' + rows[rowIndex]['apellido_materno'],
      id: isPersonal ? rows[rowIndex]['persona_id'] : rows[rowIndex]['id']
    }

    setDataToDelete(aux)
  }

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }

  const closeModalEdit = () => {
    setShowModalEdit(false)
    setEditRowIndex(null);
  }

  const handleEditClick = (index) => {

    if (isPersonal) {
      //    setEditRowIndex(index)
      setEditedRowData(rows[index]);

      setSelectedRow(rows[index])
      openView()

    } else {
      //  setEditRowIndex(index);
      setEditedRowData(rows[index]);

      setShowModalEdit(true)
    }

  };

  const handleSaveClick = () => {
    handleSave(editedRowData)
    setEditRowIndex(null);
  };

  const handleDeleteClick = () => {
    handleDelete(dataToDelete)
    closeModalDelete()
    //setEditRowIndex(null);
  }

  const handleInputChange = (e, id, type) => {
    switch (type) {
      case 'rut': let inputRut = e.target.value;
        inputRut = inputRut.slice(0, 13);
        const formattedRut = formatRut(inputRut);
        setEditedRowData({ ...editedRowData, [id]: formattedRut });
        break
      case 'phone': const regexPhone = /^[0-9]+$/;
        if (regexPhone.test(e.target.value) || e.target.value === '') {
          if (e.target.value.length < 12) {
            setEditedRowData({ ...editedRowData, [id]: e.target.value });
          }
        }
        break
      case 'number': const regexNumber = /^[0-9]+$/;
        if (regexNumber.test(e.target.value) || e.target.value === '') {
          if (e.target.value.length < 12) {
            setEditedRowData({ ...editedRowData, [id]: e.target.value });
          }
        }
        break
      case 'mail': if (e.target.value.length < 100) {
        setEditedRowData({ ...editedRowData, [id]: e.target.value });
      }
        break
      default: if (e.target.value.length < 100) {
        setEditedRowData({ ...editedRowData, [id]: e.target.value });
      }
        break
    }

  };

  return (
    <>
      <h3 style={{ marginTop: 15, marginBottom: 5 }}>{title}</h3>
      <Grid xs={12} container item justifyContent='flex-end' style={{paddingRight:25}}>

        <TextField
          size='small'
          label="Buscar"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ marginBottom: 5 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />

      </Grid>
      <TableContainer style={{paddingLeft:25, paddingRight:25}}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead style={{backgroundColor:"#f4f4f7",  }}>
            <TableRow>
              {headCells.map((headCell) => {

                if (headCell.shown) {
                  return (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align || 'left'}
                      style={{ color: TEXT_COLOR_FT, cursor: 'pointer' }}
                      onClick={() => { handleSort(headCell.id) }}
                    >
                      <Grid container alignItems='center'>
                        <Grid container item xs={11}>
                          {headCell.label}
                        </Grid>
                        <Grid container item xs={1}>
                          <span>
                            {sortConfig.key === headCell.id
                              ? sortConfig.direction === 'asc'
                                ? ' 🔼'
                                : ' 🔽'
                              : ''}
                          </span>
                        </Grid>
                      </Grid>


                    </TableCell>
                  )
                } else {
                  return null
                }
              })}
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              sortedRows.map((row, rowIndex) => {

                return <EditableRow
                  key={rowIndex}
                  row={editRowIndex === rowIndex ? editedRowData : row}
                  headCells={headCells}
                  isEditing={false}
                  isEditable={editRowIndex === null}
                  onInputChange={(e, id, type) => handleInputChange(e, id, type)}
                  onSave={handleSaveClick}
                  onDelete={() => openModalDelete(rowIndex)}
                  onEdit={() => handleEditClick(rowIndex)}
                  profesiones={profesiones}

                />
              }
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
      <RepresentanteEditModal
        openDialog={showModalEdit}
        close={closeModalEdit}
        dataCrear={editedRowData}
        fields={fields}
        setDataCrear={setEditedRowData}
        postData={handleSave}
        profesiones={profesiones}
      />
      <DeleteConfirmationModal
        openDialog={showModalDelete}
        close={closeModalDelete}
        postData={handleDeleteClick}
        deleteData={dataToDelete}
        loading={false}
      />
    </>
  );
};

RepresentantesCustomTable.propTypes = {
  headCells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default RepresentantesCustomTable;
